 //Display modals
    
 const buttonModalPairs = [
    { button: document.querySelector(".radio__button__standard"), modal: document.querySelector(".radio__modal__standard") },
    { button: document.querySelector(".radio__button__large"), modal: document.querySelector(".radio__modal__large") }
  ];

  function displayModal(modal) {
    if (modal) {
      modal.style.display = "flex";
    }
  }

  function hideModal(modal) {
    if (modal) {
      modal.style.display = "none";
    }
  }

  buttonModalPairs.forEach(pair => {
    const { button, modal } = pair;
    button.addEventListener("mouseover", () => displayModal(modal));
    button.addEventListener("mouseout", () => hideModal(modal));
  });
  

  //Sync compare at price

  const buttonStandard = document.querySelectorAll('[data-option-position="1"] fieldset > span ')[0];
  const buttonLarge = document.querySelectorAll('[data-option-position="1"] fieldset > span ')[1]

  // --- Save price at variant Standard ---

  const savePriceCompareAt = document.querySelectorAll('.selector-wrapper radio-swatch input')[1].getAttribute("data-compare-at-price")

  const getCompareAtPriceLarge = document.getElementById("compareAtPriceLarge").getAttribute("data-compare-at-price")

  const buttonLargeHandle = () => {

      //Change price of compare at price

      const changeCompareAtPrice = document.querySelectorAll('.selector-wrapper radio-swatch input')

      changeCompareAtPrice.forEach((item) => {
        item.setAttribute("data-compare-at-price", getCompareAtPriceLarge)
      })

      changeCompareAtPrice[0].click()

  }

  const buttonStandardHandle = () => {
      const changeCompareAtPrice = document.querySelectorAll('.selector-wrapper radio-swatch input')

      //Revert price of compare at price

      changeCompareAtPrice.forEach((item) => {
        item.setAttribute("data-compare-at-price", savePriceCompareAt)
      })

      changeCompareAtPrice[0].click()

  }

  if(buttonStandard) {
  buttonStandard.addEventListener("click", buttonStandardHandle);
  }


  if(buttonLarge) {
  buttonLarge.addEventListener("click", buttonLargeHandle);
  }


  //Move image of Mainslider with swatchers

  const swatcher1 = document.querySelectorAll('.selector-wrapper radio-swatch input')[0]
  const swatcher2 = document.querySelectorAll('.selector-wrapper radio-swatch input')[1]

  if (swatcher1) {
      swatcher1.addEventListener("click", function () {
        document.querySelectorAll(".media__thumb")[0].click()
      })
  }  

  if (swatcher2) {
      swatcher2.addEventListener("click", function () {
        document.querySelectorAll(".media__thumb")[1].click()
      })
  }  